<template>
	<div v-if="show" :class="slideInClass">
		<header>
			<div class="close-container">
				<a href="#" @click.prevent="close(false)">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<Edit
				v-model="career"
				:meta="meta"
			/>
		</main>
		<footer>
			<Button
				:text="career ? 'Eintrag speichern' : 'Eintrag hinzufügen'"
				:disabled="!career"
				icon="checkmark"
				@click="careerSaved"
			/>
		</footer>
		<PopUp
			v-if="showErrors"
			title="Fehlende Daten"
			ok-text="OK"
			hide-cancel
			@ok="showErrors = false"
			@hidden="showErrors = false"
		>
			<div class="mb-3 color-primary font-weight-extra-bold">Bitte überprüfe die folgenden Felder:</div>
			<ul class="content-list">
				<li v-for="(error, i) in career.errors" :key="'error-' + i">{{ error }}</li>
			</ul>
		</PopUp>
	</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Edit from "./Edit"
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/application/career/fan";
import PopUp from "@/vue/common/PopUp.vue";

export default {

	components: {
		PopUp,
		Edit,
		Button,
		Icon,
	},

	data ()
	{
		return {
			showErrors: false
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('application/career/fan', [
			'show',
		]),
		...mapState('layout', ['fanLevelClasses']),
		career: {
			get ()
			{
				return this.$store.state.application.career.fan.career;
			},

			set (value)
			{
				this.setCareer(value);
			}
		},
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['application-career-fan']
			})
		}
	},

	methods: {
		...mapActions('application/career/fan', {
			closeFan: 'close'
		}),
		...mapMutations('application/career/fan', [
			'setCareer'
		]),
		careerSaved ()
		{
			if (!this.career.valid)
			{
				this.showErrors = true;
				return;
			}

			this.close(true);
		},
		close (confirm)
		{
			this.closeFan({
				confirm
			});
		}
	}
}
</script>
